import Grid from '@mui/material/Grid'
import { useLayoutEffect } from 'react'
import moment from 'moment'
import TextField from '@mui/material/TextField'
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker'

export interface DatePickerComponentProps {
  maximumDate?: Date
  minimumDate?: Date
  eventDate?: Date
  setEventDate?: any
  setLiveSlot?: any
  setDrySlot?: any
  blockedDates?: string[]
}

export const DatePickerComponent: React.FC<DatePickerComponentProps> = ({
  minimumDate = new Date(),
  eventDate,
  setEventDate,
  maximumDate,
  setLiveSlot,
  setDrySlot,
  blockedDates
}) => {
  const disableDates = (date = new Date()): boolean => {
    if (blockedDates?.includes(moment(date).format('YYYY-MM-DD'))) return true
    return date.getDay() === 0 || date.getDay() === 6
  }

  useLayoutEffect(() => {
    moment.locale('en', { day: (day: string) => day.charAt(0).toUpperCase() })
  }, [])

  return (
    <Grid item md={6} sm={12}>
        <StaticDatePicker
          minDate={minimumDate}
          maxDate={maximumDate}
          value={eventDate}
          onChange={newValue => {
            setEventDate(newValue)
            if (typeof setLiveSlot !== 'undefined') setLiveSlot('')
            if (typeof setDrySlot !== 'undefined') setDrySlot('')
          }}
          shouldDisableDate={dateParam => disableDates(dateParam!)!}
          renderInput={(params) => <TextField {...params} />}
          componentsProps={{ actionBar: { actions: [] } }}
        />
    </Grid>
  )
}
